import { JSX } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CartArrowLeft } from "../../common/svgs/cart-arrow-left.svg";
import { ReactComponent as LogoBlack } from "../../common/svgs/logo-black.svg";
import { RouteEnum } from "../../common/enums/RouteEnum";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";
import { CartPageContent } from "./components/CartPageContent";
import { CartOrderSummary } from "./components/CartOrderSummary";
import { CartBackLinkSkeleton } from "./components/CartPageSkeletons";
import { useCart } from "./hooks/useCart";
import { useCartPageLoading } from "./hooks/useCartPageLoading";
import { CartToastContainer } from "../../common/components/cartToast/CartToastContainer";

export const CartPageContainer = (): JSX.Element => {
    const { t } = useStringTranslation();
    const { pendingOrder } = useCart();
    const isPageLoading = useCartPageLoading();
    const hasCartItems = (pendingOrder?.order_lines?.length ?? 0) > 0;
    const showSidebar = isPageLoading || hasCartItems;

    return (
        <div className="p-cart-page">
            <header className="p-cart-page__header">
                {isPageLoading ? (
                    <CartBackLinkSkeleton />
                ) : (
                    <Link
                        to={RouteEnum.REFURBISHED}
                        className="p-cart-page__back"
                    >
                        <CartArrowLeft
                            className="p-cart-page__back-icon"
                            aria-hidden
                        />
                        {t("cart-back")}
                    </Link>
                )}
                <Link
                    to={RouteEnum.REFURBISHED}
                    className="p-cart-page__logo-link"
                    aria-label="Bravilor"
                >
                    <LogoBlack className="p-cart-page__logo" />
                </Link>
            </header>
            <div
                className={
                    "p-cart-page__layout" +
                    (!showSidebar ? " p-cart-page__layout--empty" : "")
                }
            >
                <div className="p-cart-page__main">
                    <CartPageContent />
                </div>
                {showSidebar && (
                    <aside className="p-cart-page__sidebar">
                        <CartOrderSummary />
                    </aside>
                )}
            </div>
            <CartToastContainer />
        </div>
    );
};
